import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
  OnInit,
  OnDestroy,
  ChangeDetectorRef
} from '@angular/core';
import {LogManager, ModelChangeService, ModelTransformerService} from '@visana-web/basic-ui';
import {ClientModel} from 'app/model/client-model';
import {Subscription} from 'rxjs';
import {GenericValue} from '@visana-web/basic-ui';


@Component({
  selector: 'app-search-result',
  templateUrl: './search-result.component.html',
  styleUrls: ['./search-result.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class SearchResultComponent implements OnInit, OnDestroy {

  private clientModel: ClientModel;

  public searchCriteria: GenericValue;
  public gatekeepers: GenericValue[] = undefined;
  private gatekeepersAll: GenericValue[] = undefined;

  private modelChangeSubscription: Subscription;

  private readonly ZIP_SEARCHCRITERIA_FIELDNAME = "6";
  private readonly UMKREIS_SEARCHCRITERIA_FIELDNAME = "8";


  pdfLink: string
  pdfLink_network: string

  totalHits: number;

  // sorting
  key = 'name';
  reverse = false;

  sum = 90;
  step = 60;
  throttle = 200;
  scrollDistance = 1.5;
  scrollUpDistance = 2;

  constructor(
    private modelTransformerService: ModelTransformerService,
    private modelChangeService: ModelChangeService<ClientModel>,
    private ref: ChangeDetectorRef,
    private logManager: LogManager) {
  }

  ngOnDestroy(): void {
    if (this.modelChangeSubscription) {
      this.modelChangeSubscription.unsubscribe();
    }
  }

  ngOnInit() {
    if (!this.modelChangeSubscription) {
      this.modelChangeSubscription = this.modelChangeService.observableModel.subscribe(value => {
        this.clientModel = value;
        this.searchCriteria = this.clientModel.searchCriteria;
        if (this.clientModel.searchResult) {
          this.gatekeepersAll = this.modelTransformerService.getModelCollectionGenericValues(this.clientModel.searchResult, 'gateKeepers/gatekeepers');
          if (!this.gatekeepersAll) {
            this.resetList();
            return;
          }
          this.gatekeepers = this.gatekeepersAll.slice(0, this.sum);

          if (this.isOnlyZipSelected())
            this.gatekeepers = this.gatekeepers.filter(arzt =>
              this.modelTransformerService.getModelValue(arzt, 'gatekeeperPostCode/postalCode')
              != this.searchCriteria.children.find(value1 => value1.fieldName == this.ZIP_SEARCHCRITERIA_FIELDNAME)?.value
            )

          this.sort(this.key);
          this.totalHits = Number.parseInt(this.modelTransformerService.getModelValue(this.clientModel.searchResult, 'gateKeepers/totalHits'));
          if (this.totalHits > 0) {
            this.pdfLink = this.modelTransformerService.getModelCollectionValue(this.clientModel.searchResult, 'gateKeepers/relations/relations', 'type', 'gatekeeper', 'uri/string');
            this.pdfLink_network = this.modelTransformerService.getModelCollectionValue(this.clientModel.searchResult, 'gateKeepers/relations/relations', 'type', 'medicalNetwork', 'uri/string');
          }
          this.ref.detectChanges();
        } else {
          this.resetList();
          return;
        }
      });
    }
  }

  isOnlyZipSelected() {
    const filterZip = this.searchCriteria.children.find(value1 => value1.fieldName == this.ZIP_SEARCHCRITERIA_FIELDNAME);
    const umkreis = this.searchCriteria.children.find(value1 => value1.fieldName == this.UMKREIS_SEARCHCRITERIA_FIELDNAME);
    return filterZip?.value && umkreis?.value == undefined;
  }

  private resetList() {
    this.gatekeepers = undefined;
    this.totalHits = undefined;
    // sorting
    this.key = 'name';
    this.reverse = false;
    this.ref.detectChanges();
  }

  onScrollDown() {
    if (!this.gatekeepers) {
      return;
    }
    if (this.gatekeepers.length === this.gatekeepersAll.length) {
      return;
    }

    this.sum += this.step;
    this.gatekeepers = this.gatekeepersAll.slice(0, this.sum - 1);
  }

  getSortingCursorClass(): string {
    if (this.totalHits > 1) {
      return ' cursor-pointer';
    }
    return ' cursor-default';
  }

  getSortingClass(key: string) {
    if ((key === this.key) && (this.totalHits > 1)) {
      return ' vis-web-imprest-sorted-header';
    }
    return '';
  }


  public sort(key) {
    if (this.totalHits < 2) {
      this.logManager.info('Abort sorting, less than 2 entries: ' + key);
      return;
    }
    this.logManager.info('sorting: ' + key);

    const moveSmaller = this.reverse ? 1 : -1;
    const moveLarger = this.reverse ? -1 : 1;

    if (!this.gatekeepers) {
      return;
    }
    const athis = this;
    if (key === 'name') {
      this.gatekeepers.sort(function (a, b) {
        if (athis.modelTransformerService.getModelValue(a, 'displayName').toLocaleLowerCase().trim() < athis.modelTransformerService.getModelValue(b, 'displayName').toLocaleLowerCase().trim()) {
          return moveSmaller;
        }
        if (athis.modelTransformerService.getModelValue(a, 'displayName').toLocaleLowerCase().trim() > athis.modelTransformerService.getModelValue(b, 'displayName').toLocaleLowerCase().trim()) {
          return moveLarger;
        }
        return 0;
      });
    }

    if (key === 'locality') {
      this.gatekeepers.sort(function (a, b) {
        if (athis.modelTransformerService.getModelValue(a, 'displayLocality').toLocaleLowerCase().trim() < athis.modelTransformerService.getModelValue(b, 'displayLocality').toLocaleLowerCase().trim()) {
          return moveSmaller;
        }
        if (athis.modelTransformerService.getModelValue(a, 'displayLocality').toLocaleLowerCase().trim() > athis.modelTransformerService.getModelValue(b, 'displayLocality').toLocaleLowerCase().trim()) {
          return moveLarger;
        }
        return 0;
      });
    }

    if (key === 'billerType') {
      this.gatekeepers.sort(function (a, b) {
        if (athis.modelTransformerService.getModelValue(a, 'billerTypeDescription').toLocaleLowerCase().trim() < athis.modelTransformerService.getModelValue(b, 'billerTypeDescription').toLocaleLowerCase().trim()) {
          return moveSmaller;
        }
        if (athis.modelTransformerService.getModelValue(a, 'billerTypeDescription').toLocaleLowerCase().trim() > athis.modelTransformerService.getModelValue(b, 'billerTypeDescription').toLocaleLowerCase().trim()) {
          return moveLarger;
        }
        return 0;
      });
    }

    this.key = key;
    this.reverse = !this.reverse;
  }
}
